import { Component, OnInit, ViewChild } from '@angular/core';
import { ProfileService } from '../../../services/profile.service';
import {Module, AllCommunityModules } from '@ag-grid-community/all-modules';
import { EditButtonRendererComponent } from '../../../renderer/edit-button-renderer.component';
import { DeleteButtonRendererComponent } from '../../../renderer/delete-button-renderer.component';
import * as _ from 'lodash';
import { ModalDirective } from 'ngx-bootstrap/modal';
import * as moment from 'moment';
import { ConstantService } from '../../../services/constant.service';
import { ApiService } from '../../../services/api.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html'
})
export class PersonalProfileComponent implements OnInit {
  public selectedColony = [];
  public states;

  public rowSelection;
  _ = _;
  public userTypeList: any = [
    {typeCode: 'admin', permission: 'rwmd'},
    {typeCode: 'staff', permission: 'rwm'}
  ]
  dataList = [];
  departments = [];
  newForm = {
    employee_id: "",
    full_name: "",
    phone_no: "",
    work_location: "",
    designation: "",
    salary: "",
    email_id: "",
    father_name: "",
    mother_name: "",
    permanent_address: "",
    temporary_address: "",
    date_of_birth: "",
    date_of_joining: "",
    qualification: "",
    location: "",
    aadhar_no: "",
    pan_no: "",
    bank_account_no: "",
    bank_name: "",
    ifsc_code: "",
    esi_no: "",
    nominee: "",
    epf_no: "",
    nearest_epf_hospital: "",
    uan_no: "",
    phone_no_2: "",
    state: "",
    project: "",
    document_attached: "",
    attachments: ""
  }

  readonly = ['employee_id', 'designation', 'salary', 'phone_no'];
  required = ['employee_id', 'designation', 'salary', 'phone_no', 'date_of_birth', 'full_name', 'father_name', 'permanent_address',
   'document_attached', 'attachments', 'work_location', 'designation'];
  nonTextField = ['date_of_birth','document_attached', 'attachments', 'date_of_joining','state', 'project'];
  
  alert = {
    type: 'info',
    msg: '',
    timeout: 5000
  }
  dropdownList = [];
  selectedItems = [];
  dropdownSettings: IDropdownSettings = {};
  constructor(private profileService: ProfileService, private constantService:  ConstantService, private apiService: ApiService, private http: HttpClient) {
    
    this.states = this.constantService.getDataConstant('states');
    console.log(this.states);
    
    
   }

  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };
    // this.departments = this.profileService.getDepartment();
    // console.log(this.departments);
    this.listData();
    this.listProject();
    let document_list: any = [];
    let docList = this.constantService.getDataConstant('document_list');
    
    _.each(_.keys(docList), (item) => {
      document_list.push({ item_id: item, item_text: docList[item] })
    })
    this.dropdownList = document_list;
  }
  selectedData : any = {};
  listData() {
    let queryString = "* FROM `employees` WHERE  `phone_no`  LIKE '" + this.constantService.getCookies().USERNAME + "'"; 
    console.log(queryString)
    this.apiService.getCustomData(btoa(queryString)).subscribe((resp: any) => {
      this.selectedData = resp[0];
      
      this.newForm = _.clone(this.selectedData);
      delete this.newForm['srl_no'];
      delete this.newForm['action'];
      let docList = this.constantService.getDataConstant('document_list');
      if (this.newForm.document_attached) {
        let selectedList = this.newForm.document_attached.split(',');
        console.log(selectedList);
        let document_list: any = [];
        _.each(selectedList, (item) => {
  
          document_list.push({ item_id: item, item_text: docList[item] })
        })
        this.selectedItems = document_list;
      }
    })
  }
  projectList: any = [];
  listProject() {
    this.apiService.getData('project').then((resp: []) => {
      this.projectList = resp;
    })
  }
  
  

  updateProfile() {
    let that = this;
    this.newForm.document_attached = ((this.selectedItems).map(item => item.item_id)).join(',');
    this.apiService.updateDetail('employees', 'srl_no', this.selectedData.srl_no, this.newForm).subscribe((resp) => {
      console.log(resp);
      // that.resetForm();
      if(that.newForm.attachments) {
        that.uploadFile();
      }
      
      that.alert.msg = 'Data has been successfully updated.';
      setTimeout(() => {
        that.alert.msg = '';
      }, 2000)
    })
  }

  onItemSelect(e) {
  }
  onItemDeSelect(e) {
  }
  onSelectAll(items: any) {
    console.log(items);
  }

  convertLabel(label: string) {
    return label.replace(/_/g, ' ').toUpperCase();
  }

  
  formData  = new FormData();
  fileChange(index,event) {
    
    const fileList: FileList = event.target.files;
    //check whether file is selected or not
    if (fileList.length > 0) {

        const file = fileList[0];
        //get file information such as name, size and type
        console.log('finfo',file.name,file.size,file.type);
        //max file size is 4 mb
        if((file.size/1048576)<=4)
        {
          this.newForm.attachments = this.newForm.phone_no + '_document.pdf'
          this.formData.append('file', file, this.newForm.attachments);          
        }else{
          //this.snackBar.open('File size exceeds 4 MB. Please choose less than 4 MB','',{duration: 2000});
        }
        
    }

  }

  

  uploadFile() {
    this.http.post('https://e-attendance-mahaboudh.in/api/api/uploadPdf.php', this.formData).subscribe((response) => {
      console.log(response);
    })
  }


}
